import React, { useState } from 'react'
import './FilterForm.css'
import {localestr, toText} from '../utils.js'
import Edit from './Edit.js'

function FilterForm({filterData,filter,setFilter}){
    //масив filterdata : ім"я, id, тип значення, значення
    //масив filter : id, тип порівняння, значення, тип значення


    let data=[]
    for (let i=0; i<filterData.length; i++){
        data[i]={...filterData[i],compare:'='}
        if (filter!=='' && filter!==undefined){
            for (let j=0; j<filter.length; j++){
                if (filter[j].dataId===filterData[i].dataId) {data[i]={...filterData[i],...filter[j]};break}
            }
        }
    }

    const [flter,setFlter]=useState(data)

    const setCompare=(idx,d)=>{
        let n_filter=flter.slice()
        n_filter[idx].compare=d
        if(d==='lk') n_filter[idx].value=toText(n_filter[idx].value)
        setFlter(n_filter)
    }

    const setValue=(idx,d)=>{
        let n_filter=flter.slice()
        n_filter[idx].value=d
        setFlter(n_filter)
    }

    const returnFilter=()=>{
        let f=[]
        for (let i=0; i<flter.length; i++){
            if(flter[i].compare!=='' && flter[i].value!=='' && flter[i].value!==undefined) f.push({dataId:flter[i].dataId,compare:flter[i].compare,value:flter[i].value,typeVal:flter[i].typeVal})
        }
        if (f.length===0) f=''
        setFilter(f)
    }

    const items=flter.map((it,idx)=>{
        let opts=''
        let typeVal=it.typeVal
        if(it.compare==='in_f'||it.compare==='nin_f') typeVal='fld'+typeVal.substring(3)
        if (it.typeVal==='text') opts=[<option key='1' value='lk'>{localestr('містить')}</option>,<option key='2' value='nlk'>{localestr('не містить')}</option>]
        else if (it.typeVal==='number' || it.typeVal==='date' || it.typeVal==='datetime') opts=[<option key='1' value='>'>{localestr('більше')}</option>,<option key='2' value='<'>{localestr('менше')}</option>,<option key='3' value='lk'>{localestr('містить')}</option>]
        else if (it.typeVal==='catGoods' || it.typeVal==='catCounterparties' || it.typeVal==='catDiscounts') opts=[<option key='1' value='in_f'>{localestr('в папці')}</option>,<option key='2' value='nin_f'>{localestr('не в папці')}</option>,<option key='3' value='lk'>{localestr('містить')}</option>]
        else if (it.typeVal.substring(0,3)==='cat') opts=[<option key='1' value='lk'>{localestr('містить')}</option>]
        
        return <tr key={idx}>
                <td>{localestr(it.caption)}</td>
                <td><select id={idx} value={it.compare} style={{width:'95px',height:'25px'}} onChange={(e)=>{setCompare(idx,e.target.value)}}>
                        <option value=''></option>
                        <option value='='>{localestr('дорівнює')}</option>
                        <option value='<>'>{localestr('не дорівнює')}</option>
                        {opts}
                    </select></td>
                <td style={{width:'150px',boxSizing:'border-box'}}><Edit Value={it.value} typeVal={it.compare==='lk'?'text':typeVal} setVal={(d)=>{setValue(idx,d)}} /></td>
            </tr>})

    return(
        <div className='modal_f'><div className='window'>
            <div style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Фільтр')}</div><div className='closebtn' onClick={()=>{setFilter(undefined)}}/></div>
            <div className='content' style={{overflow:'visible'}}><table><tbody>{items}</tbody></table>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={returnFilter}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setFilter('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Очистити')}</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setFilter(undefined)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default FilterForm